import walletApi from 'api/walletApi'
import {
  WalletListResponse,
  WalletListRequest,
  CreateOrderResponse
} from './types'

const walletApiSlice = walletApi.injectEndpoints({
  endpoints: (build) => ({
    fetchTransactionList: build.query<WalletListResponse, WalletListRequest>({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size ?? 10,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: '/wallet',
          method: 'GET',
          params
        }
      },
      providesTags: ['wallet']
    }),
    fetchBillingList: build.query<WalletListResponse, WalletListRequest>({
      query: ({ filters, page }) => {
        const params: { [key: string]: any } = {
          size: page?.size ?? 10,
          page: page?.number ? page.number - 1 : 0
        }

        if (filters && filters.length > 0) {
          filters.forEach(({ fieldName, fieldValue }) => {
            if (
              fieldValue === null ||
              fieldValue === undefined ||
              fieldValue === '' ||
              fieldValue === 'all'
            ) {
              delete params[fieldName]
            } else {
              params[fieldName] = fieldValue
            }
          })
        }

        return {
          url: '/campaign-transactions/history',
          method: 'GET',
          params
        }
      },
      providesTags: ['wallet']
    }),
    CreateOrder: build.mutation<CreateOrderResponse, { amount: string }>({
      query: ({ amount }) => ({
        url: `/wallet/create-order?amount=${amount}`,
        method: 'POST'
      }),
      invalidatesTags: ['wallet']
    }),
    VerifyPayment: build.mutation<
      WalletListResponse,
      {
        razorpayOrderId: string,
        razorpayPaymentId: string,
        razorpaySignature: string,
        amount: string
      }
    >({
      query: ({
        razorpayOrderId,
        razorpayPaymentId,
        razorpaySignature,
        amount
      }) => ({
        url: `/wallet/payment/verify?razorpayOrderId=${razorpayOrderId}&razorpayPaymentId=${razorpayPaymentId}&razorpaySignature=${razorpaySignature}&amount=${amount}`,
        method: 'POST'
      }),
      invalidatesTags: ['wallet']
    }),
    getWalletCount: build.query<number, void>({
      query: () => ({
        url: '/wallet/balance',
        method: 'GET'
      }),
      providesTags: ['wallet']
    })
  })
})
export const {
  useCreateOrderMutation,
  useVerifyPaymentMutation,
  useGetWalletCountQuery,
  useFetchTransactionListQuery,
  useFetchBillingListQuery
} = walletApiSlice

export default walletApiSlice
